<template>
	<div id="app">
		<navbar></navbar>
		<router-view></router-view>
	</div>
</template>

<script>
	import Navbar from '@/components/navbar'
	export default {
		name: 'my-project',
		components: {
			Navbar
		}
	}
</script>

<style lang="scss">
#app {
	font-size: 0;
}


</style>



// WEBPACK FOOTER //
// src/App.vue